import type { AxiosPromise } from 'axios'
import request from '@core/request'

/**
 * 品牌分析
 * @returns {AxiosPromise}
 */
export function brandAnalyze(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/brand/analyze',
    data,
  })
}

/**
 * 品牌分析详情
 * @returns {AxiosPromise}
 */
export function brandAnalyzeDetail(analyzeId: string): AxiosPromise {
  return request({
    method: 'get',
    // baseURL: 'http://192.168.26.214:8080',
    url: `/brand/analyzeDetail/${analyzeId}`,
    data: {},
  })
}
export function analyzeList(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/brand/analyzeList',
    data,
  })
}
/**
 * 深度品牌洞察 - 执行记录（历史报告）列表
 * @returns {AxiosPromise}
 */
export function executionList(data: any, config?: Record<string, any>): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/execution/list',
    data,
    ...config,
  })
}
export function assessReportList(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/dataCenter/assessReportList',
    data,
  })
}

export function companyHistoryGen(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/historygen',
    data,
  })
}
export function companyHistoryGet(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/historyget',
    data,
  })
}
export function companyHistoryReportGen(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/historyreportgen',
    data,
    timeout: 0,
    errorMessageShow: false,
  })
}
export function getReportContent(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/dataCenter/getReportContent',
    data,
  })
}
export function companyHistoryReportGenCheck(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/historyreportgencheck',
    data,
  })
}
/**
 * 品牌分析关键词
 * @returns {AxiosPromise}
 */
export function genBrandKeyword(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand/genBrandKeyword',
    data,
  })
}
